import React from 'react';
import type { JSX, PropsWithChildren } from 'react';

import { Sidebar } from '@/components/layout/sidebar';

import './page-default.scss';

export const PageDefaultLayout: React.FunctionComponent<PropsWithChildren> = (
  props,
): JSX.Element => {
  return (
    <div className="app-layout">
      <Sidebar />
      <main>{props.children}</main>
    </div>
  );
};
